import { type Signal } from '@angular/core'
import { injectQuery } from '@tanstack/angular-query-experimental'
import { injectCartoClient } from '../services/carto.helper'
import {
  fetchPoiInfo,
  fetchPoiCompareDeliveryInfo,
  type PoiInfoFilters,
  type PoiCompareDeliveryFilters,
  type PoiDetailRow,
} from '../services/poi-info.service'

export {
  type PoiInfoFilters,
  type PoiCompareDeliveryFilters,
  type PoiDetailRow,
} from '../services/poi-info.service'

export function injectPoiInfoQuery(filters: Signal<PoiInfoFilters>) {
  const cartoClient = injectCartoClient()

  return injectQuery(() => {
    const f = filters()
    return {
      queryKey: ['poi-info', f],
      queryFn: async ({ signal }) => {
        return fetchPoiInfo(cartoClient, f, signal)
      },
      enabled: !!f.poi_id && !!f.delivery_start_date,
    }
  })
}

export function injectPoiCompareDeliveryQuery(
  filters: Signal<PoiCompareDeliveryFilters>,
) {
  const cartoClient = injectCartoClient()

  return injectQuery(() => {
    const f = filters()
    return {
      queryKey: ['poi-compare-delivery', f],
      queryFn: async ({ signal }) => {
        return fetchPoiCompareDeliveryInfo(cartoClient, f, signal)
      },
      select: (rows): [PoiDetailRow | null, PoiDetailRow | null] => {
        const ref = rows.find((r) => r.delivery_id === f.delivery_id_1) ?? null
        const comp = rows.find((r) => r.delivery_id === f.delivery_id_2) ?? null
        return [ref, comp]
      },
      enabled:
        !!f.poi_id &&
        !!f.delivery_id_1 &&
        !!f.delivery_id_2 &&
        !!f.delivery_start_date_1 &&
        !!f.delivery_start_date_2,
    }
  })
}
